import React, { useState,useEffect } from "react";
import SideBar from "../Sidebar";
import Header from "../Header";

const Layout = ({ children }) => {

    return (
        <div id="container" className="container-fluid position-relative d-flex p-0">
            <div id="mySidebar" className="sidebar">
                <SideBar />
            </div>

            <div id="main" className="content">
                <Header />
                {children}
            </div>
        </div>
    )
}

export default Layout;